import { IconProps } from "@/types/common";
import React from "react";

const BookIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.27843 1C5.09969 1 3.96923 1.46357 3.13573 2.28873C2.30224 3.11389 1.83398 4.23305 1.83398 5.4V18.6C1.83398 19.767 2.30224 20.8861 3.13573 21.7113C3.96923 22.5364 5.09969 23 6.27843 23H20.834C21.3863 23 21.834 22.5523 21.834 22V2C21.834 1.44772 21.3863 1 20.834 1H6.27843ZM10.7229 5.3C10.7229 4.74772 11.1706 4.3 11.7229 4.3H17.5007C18.0529 4.3 18.5007 4.74772 18.5007 5.3V5.5C18.5007 6.05229 18.0529 6.5 17.5007 6.5H11.7229C11.1706 6.5 10.7229 6.05228 10.7229 5.5V5.3ZM4.05621 18.6C4.05621 18.0165 4.29033 17.4569 4.70708 17.0444C5.12383 16.6318 5.68906 16.4 6.27843 16.4H18.6118C19.164 16.4 19.6118 16.8477 19.6118 17.4V20.9C19.6118 21.4523 19.164 21.9 18.6118 21.9H6.27843C5.68906 21.9 5.12383 21.6682 4.70708 21.2556C4.29033 20.8431 4.05621 19.1835 4.05621 18.6Z" />
      <path d="M5.72287 17.5C5.72287 17.6519 5.84599 17.775 5.99787 17.775H18.2257C18.3775 17.775 18.5007 17.6519 18.5007 17.5C18.5007 17.3481 18.3775 17.225 18.2257 17.225H5.99787C5.846 17.225 5.72287 17.3481 5.72287 17.5Z" />
      <path d="M6.72287 19.15C6.72287 18.9981 6.846 18.875 6.99787 18.875H18.2257C18.3775 18.875 18.5007 18.9981 18.5007 19.15C18.5007 19.3019 18.3775 19.425 18.2257 19.425H6.99787C6.846 19.425 6.72287 19.3019 6.72287 19.15Z" />
      <path d="M8.72287 20.8C8.72287 20.6481 8.846 20.525 8.99787 20.525H18.2257C18.3775 20.525 18.5007 20.6481 18.5007 20.8C18.5007 20.9519 18.3775 21.075 18.2257 21.075H8.99787C8.846 21.075 8.72287 20.9519 8.72287 20.8Z" />
    </svg>
  );
};

export default BookIcon;
